import { useState, useEffect } from 'react'
import { fetchBusinessTypes } from '../../../../helpers/lopay_api_helper'
import { BusinessTypeCategoryDto } from '../../../../api-dtos/business-types/business-types.dto.interface'

export const useMCCData = () => {
  const [mccCategories, setMccCategories] = useState<BusinessTypeCategoryDto[]>(
    [],
  )
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string>('')

  const loadMCCCategories = async () => {
    setIsLoading(true)
    setError('')
    try {
      const categories = await fetchBusinessTypes()
      setMccCategories(categories)
    } catch (error) {
      console.error('Error loading MCC categories:', error)
      setError('Failed to load business types. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadMCCCategories()
  }, [])

  return {
    mccCategories,
    isLoading,
    error,
    retry: loadMCCCategories,
  }
}
